import React, { useState } from "react";
import emailjs from "emailjs-com";
import "../styles/Contact.css";
import Footer from "../components/Footer";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
  
    try {
      const response = await fetch("https://api.cjetdispatch.com/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      if (response.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Contact form error:", error);
      setStatus("error");
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setStatus("sending");

  //   // 🔥 Replace with your actual EmailJS credentials
  //   emailjs
  //     .send(
  //       "service_xxxxx", // EmailJS Service ID
  //       "template_xxxxx", // EmailJS Template ID
  //       {
  //         from_name: formData.name,
  //         reply_to: formData.email,
  //         message: formData.message,
  //       },
  //       "public_xxxxx" // Your EmailJS Public Key
  //     )
  //     .then(
  //       () => {
  //         setStatus("success");
  //         setFormData({ name: "", email: "", message: "" });
  //       },
  //       (error) => {
  //         console.error("Email error:", error);
  //         setStatus("error");
  //       }
  //     );
  // };

  return (
    <>
      <div className="contact-container">
        {/* Left Section */}
        <div className="contact-left">
          <h1 className="contact-title">
            CONTACT <br /> US
          </h1>
          <div className="contact-info">
            <h2 className="contact-subtitle">Get In Touch</h2>
            <p className="contact-text">
              We will be glad to hear from you and make your <br /> demand as we are waiting patiently to serve you.
            </p>

            <div className="contact-item">
              <img src="/email-icon.svg" alt="email" className="contact-icon" />
              <div>
                <p className="contact-label">E-Mail</p>
                <p className="contact-detail">
                  <a href="mailto:support@cjetdispatch.com" className="contact-link">
                    support@cjetdispatch.com
                  </a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <img src="/location-icon.svg" alt="location" className="contact-icon" />
              <div>

                <p className="contact-label">🇳🇬 Nigeria Office</p>

                <p className="contact-detail">
                  2nd House Beside Mopo Barrack,
                  <br />Ilorin, Kwara State, Nigeria
                </p>
                <p className="contact-label">🇺🇸 United States Office</p>
                <p className="contact-detail">
                  70 Tripp Dr, Talladega,
                  <br />AL 35160, United States

                </p>

              </div>
            </div>

            <div className="contact-item">
              <img src="/phone-icon.svg" alt="phone" className="contact-icon" />
              <div>
                <p className="contact-label">Phone Number</p>
                <p className="contact-detail">
                  <a href="tel:+12564844152" className="contact-link">
                    +1 (256) 484-4152
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section - Contact Form */}
        <div className="contact-right">
          <div className="contact-form">
            <h2 className="form-title">Send a Message</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                className="form-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="E-mail address"
                className="form-input"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Message"
                className="form-textarea"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>

              <p className="form-info">
                By submitting, you agree to the processing of your personal <br /> data by Cjet as described in the privacy statement.
              </p>

              <div className="form-submit-container">
                <img src="/arrow-icon.svg" alt="Arrow Icon" className="submit-icon" />
                <button type="submit" className="submit-button">
                  {status === "sending" ? "Sending..." : "Submit"}
                </button>
              </div>

              {status === "success" && (
                <p className="success-msg">✅ Message sent successfully!</p>
              )}
              {status === "error" && (
                <p className="error-msg">❌ Failed to send. Try again later.</p>
              )}
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contact;
